export const DEFAULT_PRODUCTS_FILTER_PANEL_TEXT = "Filters";
export const FILTER_TOP_BAR_HEIGHT = 56;
export const FILTER_DESKTOP_WIDTH = 255;
export const FILTER_MOBILE_DRAWER_WIDTH = 400;
const PRODUCTS_FILTER_PANEL_CLASSES_PREFIX = "ProductsFiltersPanel";

export const PRODUCTS_FILTERS_CLASSES = {
  drawer: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFiltersDrawer`,
  filterContentWrapper: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterContentWrapper`,
  filterTopBar: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBar`,
  filterTitle: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTitle`,
  filterTopBarMobileSticky: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBarMobileSticky`,
  filterTopBarMobile: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBarMobile`,
  filterBtnMobile: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterBtnMobile`,
  showButtonWrapper: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterShowButtonWrapper`,
  showButtonShadow: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterShowButtonShadow`,
  topBarShadow: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBarShadow`,
};
